var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('b-button',{staticStyle:{"font-weight":"bold","border":"1px solid gray"},attrs:{"size":"sm"},on:{"click":_vm.toggle}},[_vm._v(" "+_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }